export default class SharePopup {
  static open(href) {
    const w = 600;
    const h = 300;
    const left = (window.screen.width / 2) - (w / 2);
    const top = (window.screen.height / 2) - (h / 2);
    window.open(href, 'coava', `location=1,status=1,scrollbars=1, width=${w},height=${h},top=${top},left=${left}`);
  }
}
